import { ApolloProvider } from '@apollo/react-hooks'
import { Plugins, SplashScreen, StatusBarStyle, } from '@capacitor/core'
import { IonApp, IonRouterOutlet, setupConfig } from '@ionic/react'
import { IonReactRouter } from '@ionic/react-router'
import '@ionic/react/css/core.css'
import '@ionic/react/css/display.css'
import '@ionic/react/css/flex-utils.css'
import '@ionic/react/css/float-elements.css'
import '@ionic/react/css/normalize.css'
import '@ionic/react/css/padding.css'
import '@ionic/react/css/structure.css'
import '@ionic/react/css/text-alignment.css'
import '@ionic/react/css/text-transformation.css'
import '@ionic/react/css/typography.css'
import React from 'react'
import { Provider } from 'react-redux'
import { Redirect, Route } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import LoadingScreen from './components/loading.screen'
import Menu from './components/menu'
import Notifications from './components/notifications'
import Peter from './components/peter'
import { client } from './lib/client'
import AuthRouter from './pages/Auth'
import Contact from "./pages/Contact"
import EigenheimRouter from './pages/Eigenheim'
import Additional from "./pages/Eigenheim/Additional"
import Address from "./pages/Eigenheim/Address"
import Building from "./pages/Eigenheim/Building"
import ListEntry from './pages/Eigenheim/ListEntry'
import Person from "./pages/Eigenheim/Person"
import Quote from './pages/Eigenheim/Quote'
import Summary from "./pages/Eigenheim/Summary"
import Home from './pages/Home'
import List from './pages/List'
import OnlineOrderRouter from './pages/OnlineOrdner'
import Privacy from './pages/Privacy'
import Start from "./pages/Start"
import Terms from './pages/Terms'
import { persistor, store, storeInitialize } from "./store"
import './theme/pin.css'
import './theme/variables.css'

const { StatusBar } = Plugins

const App: React.FC = () => {
  React.useEffect(() => {
    StatusBar.setStyle({
      style: StatusBarStyle.Dark
    })
    storeInitialize()(store.dispatch).then(() => {
      SplashScreen.hide()
    })
  }, [])

  setupConfig({
    mode: 'md',
  });

  return (
    <ApolloProvider client={client as any}>
      <Provider store={store}>
        <PersistGate loading={<LoadingScreen message={'Bereite Sitzung vor'} />} persistor={persistor}>
          <IonApp>
            <IonReactRouter>
              <Menu />
              <Notifications />
              <IonRouterOutlet id={'main'}>
                {/* Auth Routes */}
                <Route path={'/auth'} component={AuthRouter} />

                {/* Generic routes */}
                <Route path={'/terms'} component={Terms} />
                <Route path={'/privacy'} component={Privacy} />

                {/* Quotes */}
                <Route path="/quote/:id" component={Quote} exact={true} />

                {/* OnlineOrder Routes */}
                <Route path={'/online-ordner'} component={OnlineOrderRouter} />

                {/* eigenheim Routes */}
                <Route path={'/eigenheim'} component={EigenheimRouter} />

                {/* LEGACY - to delete later */}
                <Route path="/anfrage/:id" component={Quote} exact={true} />

                {/* TODO restructure these! */}
                <Route path="/start/:id" component={Start} exact={true} />
                <Route path="/person" component={Person} exact={true} />
                <Route path="/address" component={Address} exact={true} />
                <Route path="/building" component={Building} exact={true} />
                <Route path="/additional" component={Additional} exact={true} />
                <Route path="/summary" component={Summary} exact={true} />
                <Route path="/list" component={List} exact={true} />
                <Route path="/list/:id" component={ListEntry} exact={true} />

                <Route path="/contact/:id" component={Contact} exact={true} />
                <Route path="/home" component={Home} exact={true} />
                <Route exact path="/" render={() => <Redirect to="/home" />} />
              </IonRouterOutlet>
            </IonReactRouter>
          </IonApp>
          <Peter />
        </PersistGate>
      </Provider>
    </ApolloProvider>
  );
}

export default App;
